import { render, staticRenderFns } from "./CardknoxDeviceIpAddress.vue?vue&type=template&id=5dcb6563&"
import script from "./CardknoxDeviceIpAddress.vue?vue&type=script&lang=ts&"
export * from "./CardknoxDeviceIpAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports